import { Injectable } from '@angular/core';
import { Country } from '@shared/domain/common/country';
import { deliveries, payments } from '@shared/domain/orders/constants';
import { DeliverySettingsModel } from '@shared/domain/orders/delivery.model';
import { PaymentModel } from '@shared/domain/orders/payment.model';
import { cloneDeep } from 'lodash';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class CheckoutService {
  getDeliveries(weight: number): Observable<DeliverySettingsModel[]> {
    return of(deliveries).pipe(
      map(items => this.filterByWeight(items, weight)),
      map(items => this.mapPrices(items, weight))
    );
  }

  getPayments(): Observable<PaymentModel[]> {
    return of(payments);
  }

  filterByCountry(items: DeliverySettingsModel[], country: Country) {
    return items.filter(item => item.country === country);
  }

  filterByWeight(items: DeliverySettingsModel[], weight: number) {
    return items.filter(item => {
      let valid = true;
      if (!!item.maxWeight && weight > item.maxWeight) {
        valid = false;
      }
      if (!!item.minWeight && weight < item.minWeight) {
        valid = false;
      }
      return valid;
    });
  }

  mapPrices(items: DeliverySettingsModel[], weight: number) {
    items = cloneDeep(items);
    items.forEach(item => (item.price = this.calculatePrice(item, weight)));
    return items;
  }

  calculatePrice(item: DeliverySettingsModel, weight: number) {
    let price = item.price;
    if (Object.keys(item.weightTiers).length) {
      for (const [key, value] of Object.entries(item.weightTiers)) {
        const tier = parseInt(key);
        if (weight >= tier) price = value;
      }
    }
    return price;
  }
}
